'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// /home/wordpress/www.hochrather.at/public/wp-content/themes/releases/20250902133727/node_modules/querystring-es3/index.js
// module id = 40
// module chunks = 1